import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';
import Blocks from './components/bbcode/blocks';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import './css/index.css';
//import './css/header.css';

export default class Index extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			services: [],
			invite: [],
			invites: [],
		};
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		const x = await postApi('/v3/portal/index', params);
		console.log(x.data);
		this.setState({status: true, account: x.data.account, services: x.data.services, invite: x.data.invite, invites: x.data.invites});
		setTitle('Portal');

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

	}

	componentWillUnmount() {
	}


	

	render() {
		const user = this.context;

		const services = this.state.services.map((e,i) => {
			return (
				<Col xxl={6} xl={12} lg={12} md={6} sm={12} key={i}>
					<div className="card custom-card product-card">
						<div className="card-body">
							<div className="d-sm-flex align-items-center">
								{/*<a href="product-details.html" className="product-image-1">
									<img src="../assets/images/ecommerce/png/1.png" className="card-img" alt="..." />
								</a>*/}
								<div className="ms-1 mt-1 mt-sm-0">
									<h5 className="product-name fs-16 fw-semibold mb-0 align-items-center">{e.title}</h5>
									<Row className="gx-0 pt-3 pb-3">
										<div style={{width: 128}}>
											<img src={`https://cloud.ultrastream.io/images/${e.avatar}`} width={'90%'} />
										</div>
										<Col>
											<h4 className="mb-1 fw-semibold">
												<span>Live / Idle: <span className="text-muted ms-1  fs-14 op-6">DJ Random 1</span></span>
											</h4>
										</Col>
									</Row>
									<p className="product-description fs-13 text-muted mb-0">
										<Blocks blocks={e.description} />
										
									</p>
									
									{/*<p className="badge bg-secondary-transparent fs-11 rounded-1 mb-0">72% off</p>
									<span className="badge bg-warning-transparent rounded-1">4.2 <i className="ri-star-s-fill align-middle  d-inline-block"></i> </span>
									<span className="text-muted">(12,456)</span>
									<p className="fs-11 text-success fw-semibold mb-0 align-items-center"> Free Delivery </p>
									<div className="mt-2">
										<a href="wishlist.html" className="btn btn-sm btn-danger-light me-1"><i className="ri-heart-line"></i></a>
										<a href="cart.html" className="btn btn-sm btn-info-light me-1"><i className="ri-shopping-cart-line"></i></a>
										<a href="product-details.html" className="btn btn-sm btn-success-light"><i className="ri-eye-line"></i></a>
									</div>*/}
								</div>
							</div>
						</div> 
					</div>
				</Col>
			)
		});

		const invite = this.state.invite.map((e,i) => {
			return (
				<Col md={6} key={i}>
					<div class="card custom-card">
						<div class="card-header">
							<div class="d-flex align-items-center w-100">
								<div class="me-2">
									<span class="avatar avatar-rounded">
										<img src={`https://cloud.ultrastream.io/images/${e.avatar}?d=${Math.floor(Date.now()/1000)}`} alt="img" />
									</span>
								</div>
								<div class="">
									<div class="fs-15 fw-semibold">{e.title}</div>
									<p class="mb-0 text-muted fs-11">{moment(new Date(e.mtime)).format("L  LT")}</p>
								</div>
								<div class="dropdown ms-auto">
									{e.status === 0 && <Button size="sm" variant="info" disabled={true}>Waiting Approval</Button>}
									{e.status === 1 && <Button size="sm" variant="success" disabled={true}>Invite Approved</Button>}
									{e.status === 2 && <Button size="sm" variant="danger" disabled={true}>Invite Declined</Button>}
								</div>
							</div>
						</div>
						<div class="card-body">
							<ol class="list-group list-group-numbered">
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">Fullname:</div>
										{e.fullname?e.fullname:'Name not provided'}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">Facebook Profile Page:</div>
										{e.facebook?e.facebook:'Facobook page not provided'}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">DJ'ing Experience:</div>
										{e.djing}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">Broadcasting Experience:</div>
										{e.broadcasting}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">Link to previous set:</div>
										{e.previous?e.previous:'Link to previous set not provided'}
									</div>
								</li>
							</ol>
						</div>
					</div>
				</Col>
			)
		});
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">

								<div className="row">
                <div className="col-xxl-12 col-xl-12">
                  <div className="card custom-card overflow-hidden">
                    <div className="card-body d-sm-flex align-items-top p-4   main-profile-cover">
                      <p className="avatar avatar-xxl avatar-rounded online me-3 my-auto">
                        
                          <img src={`https://cloud.ultrastream.io${this.state.account.avatar}`} width="100%" alt="Avatar" />
                        
                      </p>
                      <div className="flex-fill main-profile-info my-auto">
                        <h5 className="fw-semibold mb-1 ">
                          {this.state.account.title?this.state.account.title:this.state.account.username}
                        </h5>
                        <div>
                          {this.state.account.radios &&
                            <p className="mb-1 text-muted">{this.state.account.radios}</p>
                          }
                          {this.state.account.country &&
                            <div className="fs-12 op-7 mb-0 d-flex">
                                {typeof this.state.account.country === "string" ?
                                <p className="me-3 mb-0"><FontAwesomeIcon icon="building" /> {this.state.account.country}</p>
                                :
                                <>
                                    <p className="me-3 mb-0"><FontAwesomeIcon icon="building" /> {this.state.account.country[1]}</p>
                                    <p className="mb-0"><FontAwesomeIcon icon="location-dot" /> {this.state.account.country[0]}</p>
                                </>
                                }
                            </div>
                          }
                        </div>
                      </div>
                      <div className="main-profile-info ms-auto">
                        <div className="">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex mb-0 ms-auto">
                              <div className="me-4">
                                <p className="fw-bold fs-20  text-shadow mb-0">0</p>
                                <p className="mb-0 fs-12 text-muted ">Followers</p>
                              </div>
                              <div className="">
                                <p className="fw-bold fs-20  text-shadow mb-0">0</p>
                                <p className="mb-0 fs-12 text-muted ">Following</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-0  mt-2 text-end">
                          {(this.state.portable=== false && (user.user.admin || user.user.user.id === this.state.account.id)) &&
                            <><Link to={user.user.admin?`/settings/${this.state.account.username}`:'/settings'}><button type="button" className="btn btn-primary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="gear" /> Settings</button></Link>&nbsp;</>
                          }
                          <button type="button" className="btn btn-secondary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="plus" /> Follow</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
								</div>

								<Row>
									{invite}
								</Row>

								<Row>
									<Col xl={12}>
										<div className="card custom-card">
											<div className="card-body p-0">
												<div className="navbar navbar-expand-xxl bg-white">
													<a className="navbar-brand" href="javascript:void(0);">
														<img src="../assets/images/brand-logos/toggle-logo.png" alt="" className="d-inline-block align-text-top" />
													</a>
													<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
														<span className="navbar-toggler-icon"></span>
													</button>
													<div className="collapse navbar-collapse navbar-justified" id="navbarSupportedContent">
														<ul className="navbar-nav me-auto mb-2 mb-lg-0 align-items-xxl-center">
															<li className="nav-item">
																<a className="nav-link active" aria-current="page" href="javascript:void(0);">Pending (0)</a>
															</li>
															<li className="nav-item">
																<a className="nav-link" href="javascript:void(0);">Active (0)</a>
															</li>
															<li className="nav-item dropdown">
																<a className="nav-link" href="javascript:void(0);">Cancelled (0)</a>
															</li>
														</ul>
													</div> 
												</div>
											</div>
										</div>
									</Col>
									{services}
									
								</Row>
							</div>

							

							{/*
							<Row>
								<Col xl={6}>
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Services
											</div>
										</div>
									</div>
								</Col>

							</Row>
							<div className="row">
								<div className="col-xl-6">
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Default alerts
											</div>
										</div>
										<div className="card-body">
											<div className="alert alert-primary" role="alert">
													A simple primary alert—check it out!
											</div>
											<div className="alert alert-secondary" role="alert">
												A simple secondary alert—check it out!
											</div>
											<div className="alert alert-success" role="alert">
												A simple success alert—check it out!
											</div>
											<div className="alert alert-danger" role="alert">
												A simple danger alert—check it out!
											</div>
											<div className="alert alert-warning" role="alert">
												A simple warning alert—check it out!
											</div>
											<div className="alert alert-info" role="alert">
												A simple info alert—check it out!
											</div>
											<div className="alert alert-light" role="alert">
												A simple light alert—check it out!
											</div>
											<div className="alert alert-dark" role="alert">
												A simple dark alert—check it out!
											</div>
										</div>
									</div>
								</div>
							</div>
							*/}
						</div>
					</div>
				}
			</>
		);
	}
}
